import { FC, useMemo } from 'react';

const WhiteLogo: FC = () => {
  return useMemo(() => {
    return (
      <img src="/GolfersHonoursLogo.png" alt="ProductLogo" loading="lazy" />
    );
  }, []);
};

export default WhiteLogo;
